import { Post, DummyPlainObject } from './Post';

export class PostList<T extends Post> {
  public readonly threadList: { [key: string]: T } = {};

  public add(post: T): void {
    this.threadList[post.id] = post;
  }

  public get(key: string): T {
    return this.threadList[key];
  }

  public count(): number {
    return this.keys().length;
  }

  public keys(): string[] {
    return Object.keys(this.threadList);
  }

  public hasKey(id:string): boolean {
    return Object.keys(this.threadList).includes(id);
  }

  public get sortedList() {
    const self = this;
    const keyList = Object.keys(this.threadList).sort((key1: string, key2:string) => {
      return self.get(key1).timestamp.getTime() - self.get(key2).timestamp.getTime()
    })

    return keyList.map((key: string) => this.get(key));
  }

  public lastUpdate(): Date {
    if (!this.keys() || this.keys().length == 0) return new Date();
    const self = this;
    const key = this.keys().reduce((before: string, current: string, index: number, arr: string[]) => {
      if (self.get(current).timestamp > self.get(before).timestamp) return current;
      return before ;
    });
    return this.get(key).timestamp;
  }
  
  public toPlainObject(): Object {
    const plainObject: DummyPlainObject = {};
    Object.keys(this.threadList).map((key: string) => {
      plainObject[key] = this.threadList[key].toPlainObject();
    })
    return plainObject;
  }
}

